import React from 'react';
import { Typography } from 'interfaces/typography';
import { useSettingsConfig } from '../hooks/useSettingsConfig';

export function SettingsTabsHeader() {
    const { sections, selectedSection, updateSelectedSection } = useSettingsConfig()
    return (
        <div className="w-full bg-white border-b border-gray-100 mb-4 flex-shrink-0">
            <div className="px-4">
                <div className="flex items-stretch flex-wrap">
                    {sections.map((section, index) => {
                        const isActive = selectedSection?.section === section.section
                        return (
                            <button
                                key={index}
                                onClick={() => updateSelectedSection(section)}
                                className={`px-3 py-3 text-sm font-medium transition-colors duration-200 ease-in-out relative border-b-2 ${
                                    isActive
                                        ? 'text-blue-600 border-blue-500 bg-blue-50/30'
                                        : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50/50 border-transparent'
                                }`}
                            >
                                <Typography 
                                    variant="mediumParagraph" 
                                    fontWeight={isActive ? "600" : "500"}
                                    color={isActive ? "#2563eb" : "#4b5563"}
                                    className="text-center"
                                >
                                    {section.section}
                                </Typography>
                            </button>
                        );
                    })}
                </div>
            </div>
        </div>
    );
} 